import { BaseEdge, getBezierPath, type Edge, type EdgeProps } from "@xyflow/react";

export interface FlowEdgeData {
  active: boolean;
  color: string;
  [key: string]: unknown;
}

export type FlowEdgeType = Edge<FlowEdgeData, "flow">;

/**
 * A plain edge plus, while `data.active` is true, a dashed overlay animated via the
 * `cs-flow-dash` keyframe (see index.css). React Flow's built-in `animated` prop reads
 * as a static dashed line at this graph's small scale; the moving dash-offset sweep
 * reads much more clearly as "data currently flowing" between nodes.
 */
export function FlowEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style,
  data,
}: EdgeProps<FlowEdgeType>) {
  const [path] = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });
  return (
    <>
      <BaseEdge id={id} path={path} markerEnd={markerEnd} style={style} />
      {data?.active && (
        <path
          d={path}
          fill="none"
          stroke={data.color}
          strokeWidth={4}
          strokeDasharray="12 8"
          strokeLinecap="round"
          className="cs-flow-dash"
          style={{ pointerEvents: "none" }}
          aria-hidden="true"
        />
      )}
    </>
  );
}
